import type { HomepageContent } from '@wix/wix-help-widget-common/homepage';
import type { UserExperience } from '@wix/wix-help-widget-common/personalization';

import { HttpClientFactory } from '../../common/httpClient';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';

const { wixBrand, clientTopology } = renderModel.get();

export const getHomepageContent = async (
  httpClient: HttpClientFactory,
  parentUrl: string,
  userExperience?: UserExperience,
): Promise<HomepageContent> => {
  try {
    const response = await httpClient.getInstance().post<HomepageContent>(clientTopology.widgetHomepageUrl, {
      brand: wixBrand,
      userExperience,
      parentUrl,
    });
    return response.data;
  } catch (error) {
    logger.error({
      message: 'Failed to fetch Homepage Content',
      error,
    });
    console.error(error);
    throw error;
  }
};
